import { render, staticRenderFns } from "./igt-developer-panel.vue?vue&type=template&id=34e95240&scoped=true&"
import script from "./igt-developer-panel.vue?vue&type=script&lang=js&"
export * from "./igt-developer-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e95240",
  null
  
)

export default component.exports